// Select all links with hashes
$('[data-smooth-scroll-fragments] a[href*="#"], [data-smooth-scroll-fragment]')
    .not('[href="#0"]')
    .click(function (event) {
        // On-page links
        if (
            location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
            &&
            location.hostname == this.hostname
        ) {
            // Figure out element to scroll to
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            // Does a scroll target exist?
            if (target.length) {

                //pre calculated offset
                var headerOffset = parseInt(target.css("scroll-margin-top"), 10);
                var targetOffset = target.offset().top;
                var calculatedOffset = targetOffset - headerOffset;

                //compensating for unknown pixel offset
                calculatedOffset = calculatedOffset + 1;

                // Only prevent default if animation is actually gonna happen
                event.preventDefault();
                $('html, body').animate({
                    scrollTop: calculatedOffset
                }, 500, function () {
                    // Callback after animation 
                    // Must change focus!
                    var $target = $(target);
                    $target.focus();
                    if ($target.is(":focus")) { // Checking if the target was focused
                        return false;
                    } else {
                        $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
                        $target.focus(); // Set focus again
                    };
                });
            }
        }
    });

$(document).on('click', '[data-scroll-to]', function () {
    var targetId = $(this).attr('data-scroll-to');

    var target = $(targetId);

    if (target.length) {

        //pre calculated offset
        var headerOffset = parseInt(target.css("scroll-margin-top"), 10);
        var targetOffset = target.offset().top;
        var calculatedOffset = targetOffset - headerOffset;

        //compensating for unknown pixel offset
        calculatedOffset = calculatedOffset + 1;

        $('html, body').animate({
            scrollTop: calculatedOffset
        }, 500, function () {
            // Callback after animation 
            // Must change focus!
            var $target = $(target);
            $target.focus();
            if ($target.is(":focus")) { // Checking if the target was focused
                return false;
            } else {
                $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
                $target.focus(); // Set focus again
            };
        });
    }
});